import ThisModule from "./PurchasesTable";

export default ThisModule;
